import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateDocumentLibraryEntryDto, DocumentLibraryEntry, HelpData } from './help-page.model';
import { IUser } from 'app/shared/models/users.model';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { ListResponse } from 'app/shared/models/list-response.model';
import { HelperService } from 'app/shared/services/helper.service';

@Injectable({
  providedIn: 'root',
})

export class HelpPageService {

  constructor(private http: HttpClient, private helperService: HelperService) {}

  getDocuments(data: DataTableStateModel): Observable<ListResponse<DocumentLibraryEntry[]>> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    return this.http.post<ListResponse<DocumentLibraryEntry[]>>('/v1/document-library/search', params);

  }

  addDocument(entry: CreateDocumentLibraryEntryDto): Observable<DocumentLibraryEntry> {
    return this.http.post<DocumentLibraryEntry>('/v1/document-library', entry);
  }

  deleteDocument(id: number): Observable<void> {
    return this.http.delete<void>(`/v1/document-library/${id}`);
  }

  getManagementTeam(skipCount: number = 0, takeCount: number = 10): Observable<IUser[]> {
    const params = new HttpParams()
      .set('SkipCount', skipCount.toString())
      .set('TakeCount', takeCount.toString());

    return this.http.get<IUser[]>('/v1/management-team', { params });
  }

  addManagementTeamMember(userId: number): Observable<any> {
    return this.http.post(`/v1/management-team/add`, null, {
      params: { id: userId.toString() },
    });
  }

  removeManagementTeamMember(id: number): Observable<void> {
    const params = new HttpParams().set('id', id.toString());

    return this.http.post<void>('/v1/management-team/remove', {}, { params });
  }

  getHelpData(type: 'GeneralHelpData' | 'CustomerSiteAddingHelpData'): Observable<HelpData> {
    const params = new HttpParams().set('type', type);

    return this.http.get<HelpData>('/v1/help', { params });
  }

  addHelpData(type: 'GeneralHelpData' | 'CustomerSiteAddingHelpData', content: string): Observable<HelpData> {
    const params = new HttpParams().set('type', type);
    const body = { content };

    return this.http.post<HelpData>('/v1/help', body, { params });
  }
}
